class MasonryGrid extends HTMLElement {
    constructor() {
      super();
      this.utils = new Utils();
      this.masonry = null;
    }
  
    get grid() {
      return this.querySelector('.grid');
    }
  
    get gutter() {
      return this.utils.isMobile() ? (this.dataset.mobileGutter || 10) : (this.dataset.desktopGutter || 20);
    }
  
    connectedCallback() {
      this.sort();
      this.init();
      this.querySelector('form').addEventListener('change', (event) => {
        this.switchBrand(event.target.dataset.brandId);
      })
    }
  
    switchBrand(brandId) {
      // View all: ordine manuale (data-all-index, da metafield pagina). Sezione: ordine del metaobject.
      const slides = brandId == 0
        ? this.items.slice().sort((a, b) => a.dataset.allIndex - b.dataset.allIndex)
        : this.items.filter(slide => slide.dataset.brandId === brandId);

      const grid = this.grid;
      grid.innerHTML = '';
    
      slides.forEach(slide => {
        slide.removeAttribute('style');
        grid.appendChild(slide)
      });
  
      if (this.masonry) {
        this.masonry.destroy();
        this.init();
      }
    }
  
    sort() {
      // Niente più ordine alfabetico: items = ordine del Liquid (sezioni + metaobject).
      this.items = Array.from(this.querySelectorAll('.grid-item'));
      this.items.forEach(slide => slide.classList.remove('tw-hidden'));
      this.switchBrand('0');
    }
  
    init() {
      const grid = this.grid;
      const options = {
        percentPosition: true,
        columnWidth: '.grid-item',
        itemSelector: '.grid-item:not(disabled)',
        fitWidth: true,
        horizontalOrder: true,
        gutter: this.gutter
      }
  
      this.masonry = new Masonry(grid, options);
    }
  }
  
  customElements.define('masonry-grid', MasonryGrid);